import React, { useState, useEffect, useContext, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  getValueOrDefaultObject,
  isEmptyEvery,
  isEmptyObject,
  isMobileDevice,
  ParseJsonSafely,
} from 'common/utilities/utils';
import CartHeaderItem from './ReusableComponents/CartHeaderItem';
import FaqComponent from './ReusableComponents/FaqComponent';
import EmptyCartPlaceholder from './ReusableComponents/EmptyCartPlaceholder';
import RecomendationItem from './ReusableComponents/RecomendationItem';
import { getList } from 'organisms/ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import { UserOrderContext } from 'context/context';
import { INDIA, CLOSED, CURRENTSTOREINFO } from 'organisms/MenusPLP/MenuPLPConstants/MenuPLPConstants';

export const deviceClass = (mobileDevice, aClass) => {
  return mobileDevice ? `${aClass}-mobile` : `${aClass}-desktop`;
};

export const checkStoreAvailablity = (from, to, initialInterval, asap, futureDates, country, unavailibilities) => {
  return getList(
    from,
    to,
    initialInterval,
    asap?.isAvailable,
    futureDates?.length === 1 && country?.toUpperCase() === INDIA,
    unavailibilities,
  );
};

const EmptyCartItems = props => {
  const { contentData = {}, faqAndContactData = {} } = props;
  const { tenantId, country } = contentData;
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const { userOrderState } = useContext(UserOrderContext);
  const [isStoreClosed, setIsStoreClosed] = useState(false);

  const { recommendedProducts } = useSelector(state => {
    return state.menuReducer || {};
  });

  const currentStoreInfoData = useMemo(() => {
    return isEmptyEvery(userOrderState.currentStoreInfo)
      ? ParseJsonSafely(localStorage.getItem(CURRENTSTOREINFO))
      : userOrderState.currentStoreInfo;
  }, [userOrderState.currentStoreInfo]);
  const {
    futureDates,
    scheduled: initiallyScheduled,
    asap,
  } = getValueOrDefaultObject(currentStoreInfoData?.summary?.timings);
  const { unavailibilities } = getValueOrDefaultObject(initiallyScheduled);
  const { interval: initialInterval = 0, startEndTime = {} } = getValueOrDefaultObject(
    initiallyScheduled?.periods?.length && initiallyScheduled?.periods[0],
  );
  const { from, to } = startEndTime;

  const updateStoreStatus = useCallback(() => {
    if (isEmptyObject(currentStoreInfoData)) {
      let storeStatus = currentStoreInfoData.summary?.status?.currentStatus;
      let availableSlots = checkStoreAvailablity(
        from,
        to,
        initialInterval,
        asap,
        futureDates,
        country,
        unavailibilities,
      );
      if (storeStatus === CLOSED && !availableSlots.length) {
        setIsStoreClosed(true);
      } else {
        setIsStoreClosed(false);
      }
    } else {
      setIsStoreClosed(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStoreInfoData]);

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };
  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  useEffect(() => {
    updateStoreStatus();
  }, [updateStoreStatus]);

  return (
    <div className={deviceClass(isMobile, 'cart-page-container')}>
      <div className={deviceClass(isMobile, 'cart-header-container')} isMobile={false}>
        <CartHeaderItem />
      </div>
      <div className={deviceClass(isMobile, 'cart-content-container')}>
        <EmptyCartPlaceholder tenantId={tenantId} />
      </div>
      <RecomendationItem
        contentData={contentData}
        storeClosedData={{ isStoreClosed }}
        recommendedProducts={recommendedProducts}
      />
      <div className={deviceClass(isMobile, 'cart-faq-container')}>
        <FaqComponent faqAndContactData={faqAndContactData} isMobile={false} history={props.history} />
      </div>
    </div>
  );
};

export default EmptyCartItems;
